// src/app/AppProviders.jsx
"use client";

import { useEffect } from "react";
import { ChakraProvider } from "@chakra-ui/react";
import { system } from "@/theme/system";
import AuthProvider from "./AuthProvider";
import {
  initBrowserTelemetry,
  TelemetryErrorBoundary,
} from "@prifina-dev/next-telemetry/client";

export default function AppProviders({ children }) {
  useEffect(() => {
    initBrowserTelemetry();
  }, []);

  return (
    <TelemetryErrorBoundary>
      <ChakraProvider value={system}>
        <AuthProvider>
          {children}
        </AuthProvider>
      </ChakraProvider>
    </TelemetryErrorBoundary>
  );
}
